<template>
    <van-dialog
            v-model="show"
            :title="title"
            show-cancel-button
            :before-close="auditConfirm"
            @cancel="auditRiskHeadShow=false"
    >
        <van-field type="text" label="本次放款" v-model="advanceAmount" :error-message="advanceAmountErr" clearable/>
        <van-field type="text" label="资金方" v-model="sourceCompanyName" readonly/>
        <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr" placeholder="请输入审批意见"/>
    </van-dialog>
</template>

<script>
    import { auditProcess } from '@/api/loanInfo'
    import { eventBus} from '../../../../../vue/utils/eventBus'
    import { mapGetters} from 'vuex'

    export default {
        name: 'loan_audit_dialog',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        watch: {
            'remark'(val) {
                if (val == undefined || val.length > 0) {
                    this.remarkErr = ''
                }
            },
            'advanceAmount'(val) {
                if (val == undefined || val.length > 0) {
                    this.advanceAmountErr = ''
                }
            }
        },
        components: {},
        computed: mapGetters([
            'auditStatus',
            'applyInfo',
            'userName',
            'name'
        ]),
        data() {
            return {
                show: false,
                advanceAmount: '',
                advanceAmountErr: '',
                sourceCompanyName: '',
                remark: '',
                remarkErr: '',
                type: '',
                process: '',
                title: ''
            }
        },
        mounted() {
            let self = this

            //初始化数据
            this.advanceAmount = this.applyInfo.advanceAmount
            this.sourceCompanyName = this.applyInfo.sourceCompanyName

            //审批
            eventBus.$on('loan-audit-dialog', function (data) {
                self.showDialog()
                self.type = data.type
                self.process = data.process
                self.title = data.title
            })

        },
        destroyed() {
            eventBus.$off('loan-audit-dialog')
        },
        methods: {
            showDialog() {
                let self = this
                this.$dialog.confirm({
                    title: '提示',
                    message: '您是否已经审核过还款计划'
                }).then(() => {
                    self.show = true
                }).catch(() => {
                    // on cancel
                    this.$toast('请先审核还款计划！')
                });
            },
            auditConfirm(action, done) {

                if (action === 'confirm') {

                    //校验是否设置了资金方
                    if (!this.sourceCompanyName) {
                        this.$toast('请通知资金管理人员先设置资金方')
                        done(false)
                        return false
                    }

                    let flag = false

                    //验证
                    if (!this.advanceAmount) {
                        this.advanceAmountErr = '请输入本次放款金额'
                        flag = true
                    }

                    //不得超出批准金额
                    if (this.advanceAmount > this.applyInfo.approveAmt) {
                        this.advanceAmountErr = '本次放款金额不得大于批贷金额'
                        flag = true
                    }

                    if (!this.remark) {
                        this.remarkErr = '请输入审批意见'
                        flag = true
                    }

                    if(flag) {
                        done(false)
                        return false
                    }

                    let params = {
                        process: this.process,
                        applyId: this.applyId,
                        type: this.type,
                        remark: this.remark,
                        advanceAmount: this.advanceAmount
                    }

                    auditProcess(params).then(res => {
                        done()
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                } else {
                    this.remarkErr = ''
                    done()
                }

            }

        }
    }
</script>

<style scoped>

</style>


